var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c("v-client-table", {
        staticClass: "w-100 vue-custom-table no-pagination disclaimers-table",
        attrs: {
          data: [_vm.defaultDisclaimer],
          columns: _vm.columns,
          options: _vm.options,
        },
        scopedSlots: _vm._u([
          {
            key: "enabled",
            fn: function () {
              return [
                _c("div", { staticClass: "form-group-checkbox" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-jelly p-smooth p-curve mr-0",
                    },
                    [
                      _c("input", {
                        staticClass: "checkbox",
                        attrs: {
                          id: "default-disclaimer-enabled",
                          type: "checkbox",
                        },
                        domProps: { checked: _vm.defaultDisclaimerEnabled },
                        on: {
                          change: function ($event) {
                            return _vm.updateDefaultDisclaimerEnabled(
                              !_vm.defaultDisclaimerEnabled
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-success" }, [
                        _c("i", { staticClass: "icon fa fa-check" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "default-disclaimer-enabled" } },
                          [
                            _c("span", { staticStyle: { display: "none" } }, [
                              _vm._v("Success"),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "message",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("pre", { staticClass: "my-2" }, [
                  _vm._v("        " + _vm._s(row.description) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "document",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "a",
                  {
                    staticClass: "text-primary clickable",
                    on: {
                      click: function ($event) {
                        return _vm.showPreviewer(row)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(row.fileName) + "\n      ")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }